import axios from 'axios';

// const TwitchParent = 'localhost';
const TwitchParent = 'hub.eventsengine.com.au';

const api = axios.create({
  // baseURL: 'http://127.0.0.1:8800/',
  // baseURL: 'https://multiview-api.friendsproject.in.th/',
  // baseURL: 'https://hub.eventsengine.com.au/multiview_api',
  baseURL: '/multiview_api',
  timeout: 5000,
});

export {
  api,
  TwitchParent
};